import { Link } from 'react-router-dom';
import { Button } from '@sandtech-hub-monorepo/ui-kit';
import React from 'react';
import { AppRoutesPaths } from '../../../../../../../apps/central-hub/src/routes/types';

export const ProgramEnrollmentsEmptyState = () => {
  return (
    <div className="px-12 py-6 gap-1 flex flex-col items-center border border-border rounded-2xl">
      <span className="text-xl font-bold">No Programs Yet</span>
      <span className="text-sm text-muted-foreground">
        Explore a world of knowledge. Start your learning journey today!
      </span>
      <Link to={AppRoutesPaths.Programs}>
        <Button variant="outline" className="mt-3">
          Apply to new programs
        </Button>
      </Link>
    </div>
  );
};
